package nl.volleyplanner.web.controller.planner.rulesets_config_v2

import kotlinx.browser.document
import kotlinx.html.div
import kotlinx.html.dom.create
import kotlinx.html.h1
import nl.volleyplanner.api.auth.AuthLevel
import nl.volleyplanner.web.base.StaticPageController
import nl.volleyplanner.web.base.WebPageController
import nl.volleyplanner.web.base.component
import nl.volleyplanner.web.component.SeasonSelectionComponent
import nl.volleyplanner.web.controller.planner.PlannerIndexController
import org.w3c.dom.HTMLElement

class PlannerTeamPouleConfigControllerV2(override val parent: PlannerIndexController) : StaticPageController() {
    override val name = "PlannerConfigurationController"
    override val title: String = "Planner Configuratie"
    override val path = "/configuration"
    override val requiredAuthLevel = AuthLevel.AdminUser
    override val childPages: List<WebPageController> = emptyList()

    override fun createRuntimeInstance() = PlannerTeamPouleConfigControllerV2(parent)

    override suspend fun renderContent(): HTMLElement {
        val seasonSelectionComponent = SeasonSelectionComponent()

        return document.create.div {
            h1 (classes = "display-5") { +"Instellingen" }
            component(seasonSelectionComponent)

            component(AllTeamsRuleConfiguratorComponent(TeamPouleConfigDataManager(seasonSelectionComponent.selectedSeasonFlow)))
        }
    }
}